import { getType } from 'typesafe-actions'
import { storeReaderAnswers } from 'sagas/downloadFromFirebase/actions'
import { select, takeLatest, call, put, take } from 'redux-saga/effects'
import { postDataToWorker } from 'components/filter/worker-actions'
import { eventChannel, END } from 'redux-saga'
import { ReaderAnswerList } from 'types/ReaderAnswerList'
import { FilterState } from 'components/filter/reducer'
import { setProcessingState } from 'actions/processing/actions'
import { setCalculations } from 'actions/calculationResults/actions'
import Worker from './filter.worker'
import { getReaderAnswers } from '../../config/selectors'
import { getFilters } from './selectors'
import { clearFilter } from 'components/filter/actions'
const filterWorker = new Worker()

const createWorkerChannel = (
  allData: ReaderAnswerList,
  filterState: FilterState
) => {
  return eventChannel(emitter => {
    const filteredDataHandler = (messageData: MessageEvent) => {
      emitter(messageData.data)
      emitter(END)
    }
    filterWorker.addEventListener('message', filteredDataHandler)
    filterWorker.postMessage(postDataToWorker({ allData, filterState }))

    return () => {}
  })
}

/** At first, put all data into the filtered data store */
export function* watchForStorageOfDownloadedAnswers() {
  yield takeLatest(getType(storeReaderAnswers), function*() {
    // Force calculations by clearing all filters
    yield put(clearFilter())
  })
}

export function* watchForFilterChanges() {
  yield takeLatest(action => /^filter\//.test(action.type), function*() {
    yield put(setProcessingState(true))
    const allData = yield select(getReaderAnswers)
    const filterState = yield select(getFilters)
    const channel = yield call(createWorkerChannel, allData, filterState)
    try {
      while (true) {
        const calculatedResults = yield take(channel)
        yield put(setCalculations(calculatedResults))
      }
    } finally {
      yield put(setProcessingState(false))
    }
  })
}
